import { useCallback } from 'react';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useLeaderBoardGetDetails = () => {
    const send = useGenericSend();

    return useCallback(async (options: Types.ILeaderBoardDetailsRequestData) => {
        const response = await send<Types.ILeaderBoardDetailsRequestData, Types.ILeaderBoardDetailsResponseData>({
            ID: 71001,
            responses: [71002, 71003],
            description: 'Get player\'s leaderboard details',
            ...options
        });

        return response;
    }, [send]);
};
